import { gql } from '@/features/graphql/generated'

export const OpenTabCreateDocument = gql(/* GraphQL */ `
    mutation OpenTabCreate($input: OpenTabCreateInput!) {
        openTabCreate(input: $input) {
            ...OpenTabSummary
        }
    }
`)

export const OpenTabUpdateDocument = gql(/* GraphQL */ `
    mutation OpenTabUpdate($openTabUuid: ID!, $input: OpenTabUpdateInput!) {
        openTabUpdate(openTabUuid: $openTabUuid, input: $input) {
            uuid
            name
        }
    }
`)

export const OpenTabCartItemAddDocument = gql(/* GraphQL */ `
    mutation OpenTabCartItemAdd($cartKey: ID, $itemAdd: CartItemAddInput!) {
        cartItemAdd(cartKey: $cartKey, itemAdd: $itemAdd) {
            ...OpenTabCart
        }
    }
`)

export const OpenTabCartItemRemoveDocument = gql(/* GraphQL */ `
    mutation OpenTabCartItemRemove($cartKey: ID!, $itemUuid: ID!) {
        cartItemRemove(cartKey: $cartKey, itemUuid: $itemUuid) {
            ...OpenTabCart
        }
    }
`)

export const OpenTabCartItemUpdateDocument = gql(/* GraphQL */ `
    mutation OpenTabCartItemUpdate($cartKey: ID!, $itemUpdate: CartItemUpdateInput!) {
        cartItemUpdate(cartKey: $cartKey, itemUpdate: $itemUpdate) {
            ...OpenTabCart
        }
    }
`)

export const OpenTabSubmissionCreateDocument = gql(/* GraphQL */ `
    mutation OpenTabSubmissionCreate($openTabUuid: ID!, $cartKey: ID!) {
        openTabSubmissionCreate(openTabUuid: $openTabUuid, cartKey: $cartKey) {
            uuid
        }
    }
`)

export const OpenTabSettleDocument = gql(/* GraphQL */ `
    mutation OpenTabSettle($openTabUuid: ID!, $input: OpenTabSettlementInput!) {
        openTabSettle(openTabUuid: $openTabUuid, input: $input) {
            uuid
        }
    }
`)
